// extracted by mini-css-extract-plugin
export default {"filled":"UserDetails_filled__eRz8P","empty":"UserDetails_empty__ItdQt"};